
import React, { useEffect, useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

const RealtimeStatus = () => {
  const [status, setStatus] = useState<'checking' | 'connected' | 'disconnected'>('checking');
  
  useEffect(() => {
    // Create a test channel to check if realtime is working
    const channel = supabase
      .channel('realtime-status-check')
      .on('presence', { event: 'sync' }, () => {
        setStatus('connected');
      })
      .subscribe((status) => {
        if (status === 'SUBSCRIBED') {
          setStatus('connected');
        } else if (status === 'CHANNEL_ERROR') {
          setStatus('disconnected');
        }
      });
      
    // Set a timeout if we don't get a response
    const timeoutId = setTimeout(() => {
      if (status === 'checking') {
        setStatus('disconnected');
      }
    }, 5000);
    
    return () => {
      clearTimeout(timeoutId);
      supabase.removeChannel(channel);
    };
  }, []);
  
  if (status === 'checking') {
    return (
      <Badge variant="outline" className="flex items-center gap-1">
        <Loader2 className="h-3 w-3 animate-spin" />
        <span>Checking...</span>
      </Badge>
    );
  }
  
  if (status === 'connected') {
    return (
      <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200 flex items-center gap-1">
        <CheckCircle className="h-3 w-3" />
        <span>Connected</span>
      </Badge>
    );
  }
  
  return (
    <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200 flex items-center gap-1">
      <XCircle className="h-3 w-3" />
      <span>Disconnected</span>
    </Badge>
  );
};

export default RealtimeStatus;
